import { watchAwaitSelector} from '../helpers'

export default function() {

	/**
	 * Pre-select the first and only mail forwarding option on the standalone form
	 *
	 * @see https://corptools.atlassian.net/browse/MT-286
	 */
	watchAwaitSelector(mailForwardingOptions => {
		if (mailForwardingOptions.length === 1) {
			mailForwardingOptions[0].click();
		}
	}, '[data-form-type="MFVOStandaloneForm"] .mf-parent .radio-row input');
}
